import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { RegisterDetailsComponent } from 'app/register/components/register-details/register-details.component';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
declare var ga: any;

@Component({
  selector: 'app-register-details-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, RegisterDetailsComponent, LanguageSelectorComponent],
  templateUrl: './register-details-section.component.html',
  styleUrls: ['./register-details-section.component.scss'],
  providers: []
})
export class RegisterDetailsSectionComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/register-details');
      ga('send', 'pageview');
    }
  }

}
